/**
 * Valid Provider variant types to indicate a PASSPORT type organisation ( Early Years ),
 * a SCHOOL for older children used in EHCP applications, or a Hybrid provider which allows logins
 * of Passport users OR School users determined by user_variant
 *
 * @readonly
 *
 * @enum {ProviderVariantType}
 */
export const ProviderVariantType = {
    PASSPORT: 1,
    SCHOOL: 2,
    PASSPORT_AND_SCHOOL: 3,
}
